import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TipsAndUpdatesIcon(props: IconProps) {
    return <Icon {...props} iconKey={"tips_and_updates"}/>
}
